import ACTIVITY_TYPES from '../../constants/day-orchestrator-activity-types';
import React from 'react';
import useAssignments from './use-assignments';
import useLabUser from './use-lab-user';
import useNextAssessment from './use-next-assessment';
import useStudentSchedule from './use-student-schedule';

// Exports
// -------

export default function useNextActivity() {
  const { activeStudentId } = useLabUser();

  const { schedule, loading: scheduleLoading } = useStudentSchedule();

  const { data: assessment, loading: assessmentsLoading } = useNextAssessment({
    studentId: activeStudentId,
  });

  const { loading: assignmentsLoading, remainingAssignments } = useAssignments({
    studentId: activeStudentId,
  });

  const loading = scheduleLoading || assessmentsLoading || assignmentsLoading;
  const [result, setResult] = React.useState({ loading: true });

  //
  // Side-Effects

  React.useEffect(() => {
    if (loading) {
      setResult((currentResult) => (currentResult.loading ? currentResult : { loading: true }));
      return;
    }

    let data;
    let type;

    const occurringEvents = schedule.filter((event) => event.occurring());

    if (occurringEvents.length) {
      data = occurringEvents;
      type = ACTIVITY_TYPES.session;
    } else if (assessment?.assessmentId) {
      data = assessment;
      type = ACTIVITY_TYPES.assessment;
    } else if (remainingAssignments?.length) {
      data = remainingAssignments[0];
      type = ACTIVITY_TYPES.assignment;
    }

    setResult((currentResult) => {
      if (!currentResult.loading && JSON.stringify(currentResult.data) === JSON.stringify(data)) {
        // If data is materially unchanged, don't update the result
        return currentResult;
      }

      return {
        data,
        loading: false,
        type,
      };
    });
  }, [assessment, loading, remainingAssignments, schedule]);

  //
  // Result

  return result;
}
